import React from "react";
import "./Footer.css";
import {Link} from "react-router-dom";

const Footer = () => {
  return (

      <>
        <div className="features-ticker">
          <div className="features-ticker-track">
            {[...Array(3)].map((_, i) => (
                <React.Fragment key={i}>
                  <div className="ticker-item">
                    <span className="ticker-icon">🚚</span>
                    <span className="ticker-title">Free Shipping</span>
                    <span className="ticker-desc">on orders over $50</span>
                  </div>
                  <span className="ticker-sep">✦</span>
                  <div className="ticker-item">
                    <span className="ticker-icon">🔄</span>
                    <span className="ticker-title">Free Exchanges</span>
                    <span className="ticker-desc">hassle-free size swaps</span>
                  </div>
                  <span className="ticker-sep">✦</span>
                  <div className="ticker-item">
                    <span className="ticker-icon">↩️</span>
                    <span className="ticker-title">Free Returns</span>
                    <span className="ticker-desc">no-questions asked</span>
                  </div>
                  <span className="ticker-sep">✦</span>
                </React.Fragment>
            ))}
          </div>
        </div>


        <footer
            className="d-flex foot flex-wrap justify-content-center align-items-center py-1 my-1 border-top flex-column ">
          <p style={{fontWeight: "350"}}>Connect with us on our Social Media</p>
          <ul className="nav justify-content-center">
            <li className="nav-item">
              <a
                  href="https://www.facebook.com/kanchanschoice/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link px-2"
              >
                <i className="fa-brands fa-facebook fa-2x"></i>
              </a>
            </li>
            <li className="nav-item">
              <a
                  href="https://www.instagram.com/kanchanschoice/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link px-2"
              >
                <i className="fa-brands fa-instagram fa-2x"></i>
              </a>
            </li>
            <li className="nav-item">
              <a
                  href="https://www.tiktok.com/@kanchanschoice"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link px-2"
              >
                <i className="fa-brands fa-tiktok fa-2x"></i>
              </a>
            </li>
          </ul>
          <p style={{fontWeight: "350"}}>
            © 2026 KanchansChoice. All Rights Reserved
          </p>
        </footer>
     </>
  );
};

export default Footer;